import {Store,Module,ActionContext} from 'vuex'
import ListModule from '../list-module'
import ListState from '../list-state'
import ClaimDeference from '../../entities/customercare/claimdeference'
import Claim from '../../entities/customercare/claim'
import Ajax from '../../../lib/ajax'
import Util from '../../../lib/util'

interface ClaimDeferenceState extends ListState<ClaimDeference>{
    editModel: ClaimDeference;
    claim: number;
    itemLoading: boolean;
}
class ClaimDeferenceModule extends ListModule<ClaimDeferenceState,any,ClaimDeference>{
    state={
        totalCount:0,
        currentPage:1,
        pageSize: 10,
        list: new Array<ClaimDeference>(),
        loading: false,
        itemLoading: false,
        editModel: new ClaimDeference(),
        activeList: new Array<ClaimDeference>(),
        claim: 0,
        path: 'claim-deferences'          
    }
    actions = Util.extend(true, this.base_actions, {
        //extra actions
    });
    mutations = Util.extend(true, this.base_mutations, {
        //extra mutations
        init(state: ClaimDeferenceState, model: Claim) {
            state.editModel = Object.assign({});
            state.claim = 0;
            if (model != undefined) {
                state.claim = model.id;
            }
        },
        new(state: ClaimDeferenceState, model: ClaimDeference) {
            state.editModel = Object.assign({});
        },
    });
}
const claimdeferenceModule=new ClaimDeferenceModule();
export default claimdeferenceModule;
